module.exports = __webpack_public_path__ + "img/label-1TRIPLA.54fe94e6.jpeg";